// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y9Bn1","col":"styles_col__2nizB"};